import logo from "./logo.png";
import nxvLogo from "./logo_original.jpeg";

import feature1 from "./feature1.png";
import feature3 from "./feature3.png";
import feature2 from "./feature2.png";

import about1 from "./about1.png";
import about2 from "./about2.png";
import about3 from "./about3.png";
import about4 from "./about4.png";

import service1 from "./service1.png";
import service2 from "./service2.png";
import service3 from "./service3.png";
import service4 from "./service4.png";

import location from "./location.png";
import contact from "./contact.png";
import email from "./email.png";

import testing from "./testing.png";
import rover from "./rover.png";

import support from "./Support.png";
import support2 from "./Support2.png";

import mission from "./mission.png";
import vision from "./vision.png";
import userImage from "./userImage.png";
import karan from "./karan.jpeg";
import slider1 from "./slider1.png";
import vsrathore from "./vsrathore.jpg";
import serviceVideo from "./mixkit-countryside-meadow-4075-hd-ready.mp4";
import serviceVideo2 from "./100914-video-2160.mp4";

export const assets = {
  serviceVideo,
  serviceVideo2,
  logo,
  nxvLogo,
  feature1,
  feature2,
  feature3,
  karan,
  slider1,
  vsrathore,

  about1,
  about2,
  about3,
  about4,

  service1,
  service2,
  service3,
  service4,

  email,
  contact,
  location,

  vision,
  mission,
  userImage,

  testing,
  rover,

  support,
  support2,
};
